import { create } from "zustand";

interface DeleteAccountStore {
  isDeleteModalOpen: boolean;
  isDeleting: boolean;
  openDeleteModal: () => void;
  closeDeleteModal: () => void;
  deleteAccount: () => Promise<void>;
}

export const useDeleteAccountStore = create<DeleteAccountStore>((set) => ({
  isDeleteModalOpen: false,
  isDeleting: false,

  openDeleteModal: () => set({ isDeleteModalOpen: true }),
  closeDeleteModal: () => set({ isDeleteModalOpen: false }),

  deleteAccount: async () => {
    set({ isDeleting: true });

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      set({ isDeleting: false, isDeleteModalOpen: false });

      window.location.href = "/login";
    } catch (error) {
      set({ isDeleting: false });
      console.error("Account deletion failed:", error);
    }
  },
}));
